import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createOrderStep",
    serviceName: "admin",
    query: gql`
      mutation createOrderStep(
        $title: String!
        $parent_id: String
        $code: String
        $details: String
      ) {
        createOrderStep(
          title: $title
          parent_id: $parent_id
          code: $code
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
